/* eslint no-undef: 0 */
import Soompi from 'soompi'

const serverEndPoints = {
  en: __SERVER_VAR_EN_API_HOST__,
  es: __SERVER_VAR_ES_API_HOST__
}

class SoompiApi extends Soompi {
  constructor(opts) {
    const opt = Object.assign((opts || {}), {apiEndpoint: __SERVER_VAR_EN_API_HOST__})
    super(opt)
  }

  setLanguage(lang) {
    this.opt = Object.assign(this.opt, {apiEndpoint: serverEndPoints[lang]})
  }
}

const headers = { 'X-Soompi-app-id': '200000a' }
const soompi = new SoompiApi({ headers })

module.exports = { soompi }



// WEBPACK FOOTER //
// ./assets/js/api/SoompiApi.js